import { Link } from "@tanstack/react-router";
import { ASSETS } from "#/lib/assets";
import { ROUTES } from "#/lib/routes";
import { useReveal } from "#/lib/useReveal";
import { EyebrowPill, PillBtn } from "../primitives.js";

const REVEAL_TRANSITION =
  "transform 900ms cubic-bezier(0.22, 1, 0.36, 1), opacity 700ms ease-out";

export function OnSale() {
  const { ref, revealed } = useReveal<HTMLDivElement>(0.4);
  return (
    <section className="overflow-x-clip pt-20 pb-24 md:pt-32 md:pb-40">
      <div className="lg:hidden mx-auto w-full max-w-figma px-6">
        <EyebrowPill className="mb-3" variant="yellow">
          Limited Time
        </EyebrowPill>
        <h2 className="m-0 font-display font-extrabold text-5xl text-lp-green-mid leading-none tracking-tight">
          ON SALE
        </h2>
        <div className="mt-3 font-bold font-display text-xl text-lp-green-dk">
          GREAT BOOKS, BETTER PRICES
        </div>
        <p className="m-0 mt-2 font-display text-sm text-lp-text">
          Special offers for curious minds.
        </p>
        <img
          src={ASSETS.onSaleFan}
          alt="Books on sale"
          loading="lazy"
          decoding="async"
          className="mx-auto mt-6 block w-full max-w-[340px] object-contain"
        />
        <div className="mt-8">
          <Link to={ROUTES.sale}>
            <PillBtn variant="green">Shop Now</PillBtn>
          </Link>
        </div>
      </div>

      <div
        ref={ref}
        className="hidden lg:block mx-auto w-full max-w-figma px-6 md:px-10"
      >
        <div className="flex flex-col-reverse items-center gap-10 lg:flex-row lg:items-center lg:gap-12">
          <div
            className="flex-1"
            style={{
              opacity: revealed ? 1 : 0,
              transform: revealed ? "translateX(0)" : "translateX(-60px)",
              transition: REVEAL_TRANSITION,
            }}
          >
            <h2 className="m-0 whitespace-nowrap font-display font-extrabold text-6xl text-lp-green-mid leading-none tracking-tight md:text-7xl lg:text-8xl">
              ON SALE
            </h2>
            <div className="mt-4 font-bold font-display text-xl text-lp-green-dk md:text-2xl lg:text-3xl">
              GREAT BOOKS, BETTER PRICES
            </div>
            <p className="m-0 mt-2 font-display text-sm text-lp-text md:text-base">
              Special offers for curious minds.
            </p>
            <div className="mt-8 md:mt-10">
              <Link to={ROUTES.sale}>
                <PillBtn variant="green">Shop Now</PillBtn>
              </Link>
            </div>
          </div>

          <div
            className="relative flex-1"
            style={{
              opacity: revealed ? 1 : 0,
              transform: revealed ? "translateX(0)" : "translateX(60px)",
              transition: REVEAL_TRANSITION,
              transitionDelay: "120ms",
            }}
          >
            <img
              src={ASSETS.onSaleFan}
              alt="Books on sale"
              loading="lazy"
              decoding="async"
              className="mx-auto block w-full max-w-[520px] object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
